module.exports = __webpack_public_path__ + "media/images/emblems/Vuadens-coat_of_arms-be21d6a73e543335a23842bbe4b5be0a.svg";